module.exports = __webpack_public_path__ + "img/9577ac4.jpg";